export enum SubscriptionTiers {
   Free = 'Free',
   Paid = 'Paid',
}
export enum SubscriptionProviders {
   Google = 'Google',
   Apple = 'Apple',
   Stripe = 'Stripe',
}

export interface Subscription {
   tier: SubscriptionTiers;
   paymentProvider?: SubscriptionProviders;
   expirationDate: number; // unix timestamp
   token?: string;
}
